// not set in sitecore so this is the single place to change this in pdp
const DEFAULT_INCREMENT_UNIT = "unit";
const DEFAULT_MINIMUM_INCREMENT_AND_QUANTITY = 1; 
const DEFAULT_MOQ = 1;
// this is currently the default not set in sitecore, It can be chagned here or DEFAULT_MINIMUM_INCREMENT_AND_QUANTITY can be used as an example to update it
const ADD_TO_CART_MAX = 9999;
const DEFAULT_MOQ_HELP_TEXT ="Must be ordered with a quantity greater than";
const DEFAULT_MIN_INCREMENT_QTY_HELP_TEXT = "Must be ordered in increments of";
export default {
  namespaced: true,
  state: {
    incrementQuantity: null,
    incrementLabel: null,
    min: null,
    count: null,
    displayCount: null,
    showError: false,
    errorMsg: "",
    validCartCount: 1,
    usingDefaultUnit: true,
    hasDefaultHelpText: false
  },
  getters: {
    getMin: state => state.min,
    getIncrementQuantity: state => state.incrementQuantity,
    getIncrementLabel: state => state.incrementLabel,
    getShowError: state => state.showError,
    getHasDefaultHelpText : state =>state.hasDefaultHelpText,
    countErrorDisableAddToCart: (_state) =>{
      return _state.showError && !_state.hasDefaultHelpText;
    },
    getErrorMsg: state => state.errorMsg,
    getValidCartCount: state => state.validCartCount,
    getUsingDefaultUnit: (_state, getters) => {
      const uom = getters.getMinimumOrderUnitOfMeasure;
      return uom === DEFAULT_INCREMENT_UNIT;
    },
    getMOQ: (
      _state,
      _getters,
      _rootState,
      rootGetters
    ) => {
      const productSku = rootGetters["product/getProductSku"];
      if (productSku && productSku.MinimumOrderQuantity) {
        return parseInt(productSku.MinimumOrderQuantity);
      }
      return DEFAULT_MOQ;
    }, 
    getMinimumAndIncrementQuantity: (
      _state,
      _getters,
      _rootState,
      rootGetters
    ) => {
      const productSku = rootGetters["product/getProductSku"];
      if (productSku && productSku.MinimumOrderQuantity) {
        return parseInt(productSku.MinimumOrderQuantity); //TODO : need to replace with Minimum Increment quantity once ready
      }
      return DEFAULT_MINIMUM_INCREMENT_AND_QUANTITY;
    },
    getMinimumOrderUnitOfMeasure: (
      _state,
      _getters,
      _rootState,
      rootGetters
    ) => {
      const productSku = rootGetters["product/getProductSku"];
      if (productSku && productSku.MinimumOrderUOM) {
        return productSku.MinimumOrderUOM.toLowerCase() == 'ea' ? 'unit' : productSku.MinimumOrderUOM.toLowerCase();
      }
      return DEFAULT_INCREMENT_UNIT;
    },
    cartMax: () => ADD_TO_CART_MAX
  },
  mutations: {
    UPDATE_SHOW_ERROR(state, showError) {
      state.showError = showError;
    },
    UPDATE_ERROR_MSG(state, errorMsg) {
      state.errorMsg = errorMsg;
    },
    UPDATE_VALID_CART_COUNT(state, newCartCount) {
      state.validCartCount = newCartCount;
    },
    UPDATE_DEFAULT_HELPTEXT(state,hasDefaultHelpText){
      state.hasDefaultHelpText = hasDefaultHelpText;
    }
  },
  actions: {
    updateErrorStates({ commit }, newErrorMsg) {
      const noErrorMessage = 0;
      const updatedShowError = newErrorMsg.trim().length !== noErrorMessage;
      commit("UPDATE_SHOW_ERROR", updatedShowError);
      commit("UPDATE_ERROR_MSG", newErrorMsg);
      commit("UPDATE_DEFAULT_HELPTEXT",  newErrorMsg.trim().length>0 && (newErrorMsg.startsWith(DEFAULT_MOQ_HELP_TEXT) || 
                newErrorMsg.startsWith(DEFAULT_MIN_INCREMENT_QTY_HELP_TEXT)));
    },
    updateValidCartCount({ commit }, newCount) {
      commit("UPDATE_VALID_CART_COUNT", newCount);
    }
  }
};
